import { LOCATION_NAME_MAX_LENGTH, type LocationFormValues } from '@/definitions/location'
import { validatePhoneNumber } from '@/utils/phoneUtils'
import { validatePostalCode } from '@/utils/postalUtils'

/**
 * Whether the collected values are complete enough to create the location.
 *
 * Covers the request schema's required set, so the user is stopped here rather
 * than by a 422 they cannot act on, plus `state` — which the endpoint accepts as
 * absent but a practice's record is expected to carry, so every form asks for it
 * regardless. `suite` is the only field left genuinely optional.
 *
 * Shared by every surface that creates a location, so they hold the values to the
 * same standard without keeping separate copies of the rule in step.
 */
export const isLocationCreatable = (values: LocationFormValues): boolean => {
  const locationName = values.location_name.trim()

  return (
    locationName.length > 0 &&
    locationName.length <= LOCATION_NAME_MAX_LENGTH &&
    values.street.trim().length > 0 &&
    values.city.trim().length > 0 &&
    validatePostalCode(values.postal_code) === '' &&
    values.state !== '' &&
    values.timezone !== '' &&
    validatePhoneNumber(values.primary_phone) === ''
  )
}
